"use strict";

function resizeWindow() {}
function scrollDown() {}

function changeBookingLink(idSelect) {
	var currentSelect = document.getElementById("discountSpecial-" + idSelect);
	document.getElementById("bookSpecial-" + idSelect).href = currentSelect.value;
}

$(document).ready(function () {

	// map function homepage
	$('li#pin-1, .pin-1').click(function () {
		$('li#pin-1').addClass('active');
		$('li#pin-2').removeClass('active');
		$('li#pin-3').removeClass('active');
		$('li#pin-4').removeClass('active');
		$('li#pin-5').removeClass('active');
		// Active pin
		$('.pin-1').addClass('active');
		$('.pin-2').removeClass('active');
		$('.pin-3').removeClass('active');
		$('.pin-4').removeClass('active');
		$('.pin-5').removeClass('active');
	});

	$('li#pin-2, .pin-2').click(function () {
		$('li#pin-1').removeClass('active');
		$('li#pin-2').addClass('active');
		$('li#pin-3').removeClass('active');
		$('li#pin-4').removeClass('active');
		$('li#pin-5').removeClass('active');
		// Active pin
		$('.pin-1').removeClass('active');
		$('.pin-2').addClass('active');
		$('.pin-3').removeClass('active');
		$('.pin-4').removeClass('active');
		$('.pin-5').removeClass('active');
	});

	$('li#pin-3, .pin-3').click(function () {
		$('li#pin-1').removeClass('active');
		$('li#pin-2').removeClass('active');
		$('li#pin-3').addClass('active');
		$('li#pin-4').removeClass('active');
		$('li#pin-5').removeClass('active');
		// Active pin
		$('.pin-1').removeClass('active');
		$('.pin-2').removeClass('active');
		$('.pin-3').addClass('active');
		$('.pin-4').removeClass('active');
		$('.pin-5').removeClass('active');
	});

	$('li#pin-4, .pin-4').click(function () {
		$('li#pin-1').removeClass('active');
		$('li#pin-2').removeClass('active');
		$('li#pin-3').removeClass('active');
		$('li#pin-4').addClass('active');
		$('li#pin-5').removeClass('active');
		// Active pin
		$('.pin-1').removeClass('active');
		$('.pin-2').removeClass('active');
		$('.pin-3').removeClass('active');
		$('.pin-4').addClass('active');
		$('.pin-5').removeClass('active');
	});

	$('li#pin-5, .pin-5').click(function () {
		$('li#pin-1').removeClass('active');
		$('li#pin-2').removeClass('active');
		$('li#pin-3').removeClass('active');
		$('li#pin-4').removeClass('active');
		$('li#pin-5').addClass('active');
		// Active pin
		$('.pin-1').removeClass('active');
		$('.pin-2').removeClass('active');
		$('.pin-3').removeClass('active');
		$('.pin-4').removeClass('active');
		$('.pin-5').addClass('active');
	});

	// Blog read more functionality
	$('.read-more').append("Read More");
	$('.read-more').click(function (event) {
		if (!$(this).hasClass('open')) {
			$(this).prev().slideDown();

			//Change text Close to Menu
			$(this).text(function () {
				return $(this).text().replace("Read More", "Read Less");
			});

			$(this).addClass('open');
		} else {
			$(this).removeClass('open');
			$(this).prev().slideUp();

			//Change text Close to Menu
			$(this).text(function () {
				return $(this).text().replace("Read Less", "Read More");
			});
		}
	});

	$('#menu_text').append("Menu");
	$('.hamburger').click(function (event) {
		if ($(this).hasClass('is-active')) {
			$('#primary-nav').hide();

			//Change text Close to Menu
			$("#menu_text").text(function () {
				return $(this).text().replace(" ", "Menu");
			});
		} else {
			$('#primary-nav').show();

			//Change text menu to close 
			$("#menu_text").text(function () {
				return $(this).text().replace("Menu", " ");
			});
		}
		$(this).toggleClass('is-active');
	});

	// Specials call now button
	$('#special3031').find('.book-now').text('Call Now');

	//Call function with browser is resized.
	$(window).resize(function (event) {
		resizeWindow();
	});
	resizeWindow();

	//Acts when scroll down page.
	$(window).scroll(function (event) {
		scrollDown();
		var top = $(document).scrollTop();
		if (top > 0) {} else {}
	});

	// Main Nav Dropdown
	$("#primary-nav li").hover(function () {

		$(this).addClass("hover");
		$('ul.submenu', this).fadeIn(200);
	}, function () {

		$(this).removeClass("hover");
		$('ul.submenu', this).fadeOut(200);
	});
	//Home page scroll down arrow. If present.
	$('.arrow-home').click(function (event) {
		$('body, html').animate({
			scrollTop: $(window).height() - $('header').outerHeight() }, 800, 'easeOutExpo');
	});
	//Home page scroll down arrow. If present.
	$('.scroll_down').click(function (event) {
		$('body, html').animate({
			scrollTop: $(window).height() - $('header').outerHeight() }, 1000, 'easeOutExpo');
	});

	$('.book-trigger').click(function () {
		$('#booking-form').slideDown();
	});
	$('#booking-form .close').click(function () {
		$('#booking-form').slideUp();
	});

	$('.open-terms').click(function () {
		var target = $(this).attr('href');
		if ($(this).hasClass('open')) {
			$(this).removeClass('open');
			$(target).slideUp();
		} else {
			$(this).addClass('open');
			$(target).slideDown();
		}
		return false;
	});

	//Slick Slider
	$('.sym-slides').slick();

	//Event Tracking
	$('.book-now').on('click', function () {
		ga('send', 'event', 'reservations', 'click', 'book now');
	});
	$('.bookNow').on('click', function () {
		ga('send', 'event', 'header widget', 'click', 'book now');
	});

	//Check in and check out datepicker for booking engine
	$("#CheckIn").datepicker({
		//showOn: "both",
		//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		//buttonImageOnly: true,
		changeMonth: true,
		numberOfMonths: 2,
		minDate: new Date(2020, 5 - 1, 1),
		onSelect: function onSelect(selectedDate) {
			getDate = $(this).datepicker('getDate');
			newDate = new Date(getDate.getTime());
			newDate.setDate(newDate.getDate() + 3);
			$("#CheckOut").datepicker("setDate", newDate);
			$("#CheckOut").datepicker("option", "minDate", selectedDate);
		}
	});
	$("#CheckOut").datepicker({
		//showOn: "both",
		//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		//buttonImageOnly: true,
		changeMonth: true,
		numberOfMonths: 2,
		minDate: new Date(2020, 5 - 1, 1),
		onSelect: function onSelect(selectedDate) {
			$("#CheckIn").datepicker("option", "maxDate", selectedDate);
		}
	});
});